/**
 * Culians — Country Bar
 *
 * Suggests switching to the visitor's own market when they are
 * browsing another one. Detection uses Shopify's first-party
 * endpoint /browsing_context_suggestions.json (IP based, no
 * third-party service, no extra cookies).
 *
 * Sequencing: never shown on top of the cookie banner. If the
 * cookie choice is already stored the bar appears after a short
 * delay; otherwise it waits for the cookie banner to close.
 *
 * Dismissal: "Not now", or a manual change of the footer country
 * selector, stores a 30 day dismissal in localStorage.
 *
 * Testing: ?culians_country=DE forces the detected country.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'culians_country_suggest';
  var COOKIE_KEY = 'culians_cookie_consent';
  var DISMISS_TTL_MS = 30 * 24 * 60 * 60 * 1000;
  var REVEAL_DELAY_MS = 900;

  var bar = document.getElementById('culians-country');
  if (!bar) return;

  var countries = {};
  try { countries = JSON.parse(bar.getAttribute('data-countries') || '{}'); } catch (e) { countries = {}; }
  var current = bar.getAttribute('data-current') || '';
  var inclusive = (bar.getAttribute('data-inclusive') || '').split(',');

  /* ─── Persistence ──────────────────────────────────────── */

  function isDismissed() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed.timestamp !== 'number') return false;
      return Date.now() - parsed.timestamp < DISMISS_TTL_MS;
    } catch (e) { return false; }
  }

  function dismiss() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ timestamp: Date.now() }));
    } catch (e) { /* private mode: fine */ }
  }

  function cookieChoiceStored() {
    try { return !!localStorage.getItem(COOKIE_KEY); } catch (e) { return true; }
  }

  /* ─── Open / close ─────────────────────────────────────── */

  function open() {
    bar.setAttribute('data-open', 'true');
    bar.setAttribute('aria-hidden', 'false');
  }

  function close() {
    bar.setAttribute('data-open', 'false');
    bar.setAttribute('aria-hidden', 'true');
  }

  /* ─── Copy ─────────────────────────────────────────────── */

  function sentence(code) {
    var c = countries[code];
    var name = c.name;
    var withThe = (code === 'US' || code === 'GB' || code === 'NL') ? 'the ' + name : name;
    var text = 'It looks like you are visiting from ' + withThe + '. Switch to ' + name + ' (' + c.currency + ')';
    if (inclusive.indexOf(code) !== -1) {
      text += ' to see prices with duties and taxes included.';
    } else {
      text += ' to see prices in ' + c.currency + '.';
    }
    return text;
  }

  /* ─── Detection ────────────────────────────────────────── */

  function detect() {
    var forced = null;
    try {
      forced = new URLSearchParams(window.location.search).get('culians_country');
    } catch (e) { forced = null; }
    if (forced) return Promise.resolve(forced.toUpperCase());

    var url = '/browsing_context_suggestions.json?country%5Benabled%5D=true&source=culians';
    return fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j.detected_values || !j.detected_values.country) return null;
        return j.detected_values.country.handle || null;
      })
      .catch(function () { return null; });
  }

  /* ─── Switch ───────────────────────────────────────────── */

  function switchTo(code) {
    var form = document.getElementById('CuliansCountryForm');
    var input = bar.querySelector('[data-culians-country-input]');
    if (!form || !input) return;
    input.value = code;
    var ret = form.querySelector('input[name="return_to"]');
    if (ret) ret.value = window.location.pathname + window.location.search;
    form.submit();
  }

  /* ─── Show when ready ──────────────────────────────────── */

  function maybeShow(code) {
    if (!code || code === current || !countries[code]) return;
    var textEl = bar.querySelector('[data-culians-country-text]');
    if (textEl) textEl.textContent = sentence(code);

    var sw = bar.querySelector('[data-culians-country-switch]');
    var dm = bar.querySelector('[data-culians-country-dismiss]');
    if (sw) sw.addEventListener('click', function () { dismiss(); switchTo(code); });
    if (dm) dm.addEventListener('click', function () { dismiss(); close(); });

    function reveal() { setTimeout(open, REVEAL_DELAY_MS); }

    var cookie = document.getElementById('culians-cookie');
    if (!cookie || cookieChoiceStored()) { reveal(); return; }

    // Wait for the cookie banner to close, then reveal.
    var seenOpen = cookie.getAttribute('data-open') === 'true';
    var obs = new MutationObserver(function () {
      var isOpen = cookie.getAttribute('data-open') === 'true';
      if (isOpen) { seenOpen = true; return; }
      if (seenOpen) { obs.disconnect(); reveal(); }
    });
    obs.observe(cookie, { attributes: true, attributeFilter: ['data-open'] });
  }

  /* ─── Footer selector: a manual change counts as a choice ── */

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.id === 'FooterLocalizationForm') dismiss();
  }, true);
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.id === 'FooterCountrySelect') dismiss();
  }, true);

  /* ─── Boot ─────────────────────────────────────────────── */

  function boot() {
    if (isDismissed()) return;
    if (window.Shopify && window.Shopify.designMode) return;
    detect().then(maybeShow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
